<script>
import baseList from "@/views/components/base/baseList.vue";
import config from "@/../config";
import supplierTemplate from "../components/common/form/supplierTemplate.vue";

let customerId = window.localStorage.getItem("customerId");
import { Tag, Button } from "view-design";
import Vue from "vue";

export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "supplier",
        key: "id",
        url: {
          list: "/admin/system/supplier/list",
          del: "/admin/system/supplier",
        },
        output: false,
      },
      // menus: [
      //   {
      //     label: "常用语",
      //     name: "commondescr_list_main",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "服务字典",
      //     name: "serveKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "知识库",
      //     name: "issueKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "知识库审核",
      //     name: "auditKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "工单类型",
      //     name: "worktype_list",
      //     auth: "system/worktype/index",
      //   },
      //   {
      //     label: "供应商",
      //     name: "supplier_main",
      //     auth: "system/supplier/index",
      //   },
      //   {
      //     label: "资产类型",
      //     name: "deviceClass_list",
      //     auth: "system/deviceClass/index",
      //   },
      //   {
      //     label: "耗材分类",
      //     name: "consumablesClass_list",
      //     auth: "system/consumablesClass/index",
      //     show: !(Number(customerId) === 0),
      //   },
      //   {
      //     label: "楼宇管理",
      //     name: "offices_building_list",
      //     auth: "system/offices/index",
      //   },
      //   {
      //     label: "巡检模板",
      //     name: "templateManagement_list",
      //     auth: "system/templateManagement/index",
      //   },
      // {
      //               label: "巡检类别",
      //               name: "category_list",
      //               auth: "",
      //           },
      //   {
      //     label: "巡检项",
      //     name: "scene_list",
      //     auth: "system/scene/index",
      //   },
      //   {
      //     label: "坐席列表",
      //     name: "callConfig_list",
      //     auth: "/admin/callConfig/lists",
      //   },
      //
      //   {
      //     label: "投诉管理",
      //     name: "feedback_list",
      //     auth: "/admin/feedback/lists",
      //   },
      //   {
      //     label: "绩效列表",
      //     name: "performance_list",
      //     auth: "",
      //   },
      //   {
      //     label: "绩效管理",
      //     name: "performance_manage",
      //     auth: "",
      //   },
      //   {
      //     label: "考勤组",
      //     name: "attendance_list",
      //     auth: "",
      //   },
      //   {
      //     label: "排班管理",
      //     name: "scheduling_list",
      //     auth: "",
      //   },
      //   {
      //     label: "流程管理",
      //     name: "approvalProcess_list",
      //     auth: "",
      //   },
      // ],
      actions: [
        {
          label: Number(customerId) == 0 ? '新增客户' : '新增供应商',
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "",
        },
        {
          label: '下载模板',
          icon: 'md-log-out',
          type: 'info',
          onClick: this.toDownload,
          auth: "",
        },
        {
          label: "导入",
          icon: "md-cloud-upload",
          onClick: this.toImport,
          auth: "",
          type: "info",
        },
      ],
      filters: [
        {
          label: "项目名称",
          name: "projectId",
          value: "",
          type: "select",
          KeyEnter: this.search,
          dropList: [],
        },
        {
          label: Number(customerId) == 0 ? '客户名称' : '供应商名称',
          name: "supplierName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },

      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: Number(customerId) == 0 ? '客户名称' : '供应商名称',
          key: "supplierName",
          width: 270,
          tooltip: "true",
          align: "center",
          render: (h, params) => {
            const text = params.row.supplierName
            return <div style="text-align: left;">{text}</div>
          }
        },
        {
          title: '项目',
          minWidth: 280,
          align: 'center',
          render: (h, params) => {
            let list = params.row.projectIds ? params.row.projectIds.split(',') : []
            let proList = this.projectList
            let htmlArr = []
            for (let i = 0; i < list.length; i++) {
              if (list.length > 0) {
                for (let z = 0; z < proList.length; z++) {
                  if (list[i] == proList[z].id) {
                    console.log(list);

                    htmlArr.push(
                      <div onClick={() => this.toInfoProject(proList[z].id)} style="cursor: pointer; color:#4991ff; text-align: left;" >{proList[z].name}
                        {proList[z].percentage ? (<span style="margin-right: 6px">
                          ({proList[z].percentage}%)
                        </span>) : ''}
                        {((proList[z].percentage != null) && (proList[z].percentage > 0) && (proList[z].percentage < 100)) ?
                          (<span style="background-color: #fcd9dd;color: #ec0019;border-radius: 5px;padding: 0 5px;">
                            {Number(customerId) == 0 ? "跟进中" : "建设中"}
                          </span>) : ''}
                        {proList[z].percentage == 100 ? (<span style="  background-color: #e4f3e5;color: #4baf50;border-radius: 5px;padding: 0 5px;">
                          {Number(customerId) == 0 ? "已成交" : "已完成"}
                        </span>) : ''}
                        {proList[z].percentage == null || proList[z].percentage == 0 ? (<span style="  background-color: #fafcd9;color: #bdc824;border-radius: 5px;padding: 0 5px;">
                          未开始
                        </span>) : ''}
                        {(list.length == 1) || (list.length - 1 == i) ? '' : '，'}</div>
                    )
                  }

                }
              }

            } return (<div>{htmlArr}</div>)
          }
        },
        {
          title: "状态",
          key: "state",
          width: 130,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state === 1
                ? "提需求"
                : row.state === 2
                  ? "需求沟通"
                  : row.state === 3
                    ? "正式立项"
                    : row.state === 4
                      ? "预算申报"
                      : row.state === 5
                        ? "上会通过"
                        : row.state === 6
                          ? "院内谈判"
                          : row.state === 7
                            ? "公开调研"
                            : row.state === 8
                              ? "招投标"
                              : row.state === 9
                                ? "签订合同"
                                : row.state === 10
                                  ? "服务中"
                                  : row.state === 11
                                    ? "lost"
                                    : row.state === 12
                                      ? "潜在"
                                      : "";
            return <span style={{ "font-size": "14px" }} >{text}</span>;
          },
        },
        {
          title: "性质",
          key: "supplierNature",
          width: 130,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.supplierNature === 1 ? "厂家" : row.supplierNature === 2 ? "代理" : "";
            return <span style={{ "font-size": "14px" }} >{text}</span>;
          },
        },
        {
          title: "项目经理",
          width: 130,
          tooltip: "true",
          key: "projectManager",
          align: "center",
        },
        {
          title: "电话",
          width: 130,
          tooltip: "true",
          key: "telephone",
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 180,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, row, param) => {
              let item = param.row;
              return (
                <Button
                  size="small"
                  onClick={() => this.toinfo(item)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  详情
                </Button>
              );
            },
            "edit",
            "delete",
          ],
        },
      ],
      projectList: []
    };
  },
  created() {
    this.loadProject()
  },
  methods: {
    toInfoProject(row) {
      window.localStorage.setItem("projectId", row);
      $utils.url.push({
        name: "panorama",
      });
    },
    async loadProject() {
      this.content = "";
      let q = {
        status: 2,
      };
      let res = await $utils.api.load("/admin/system/management/listAll", q, "get");
      if (res.code == 200) {
        this.projectList = res.data;
        let ll = res.data;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.name;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        console.log(dropList);

        for (let index = 0; index < this.filters.length; index++) {
          const element = this.filters[index];
          if (element && element.name == "projectId") {
            this.filters[index]["dropList"] = dropList
          }
        }
      }
    },
    toAdd() {
      $utils.url.push({ name: "supplier_edit", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "supplier_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
    toinfo(row) {
      $utils.url.push({
        name: "supplier_Info",
        query: {
          info: row,
        },
      });
    },
    toDownload() {
      // console.log(config.API_HOST);

      window.location.href =
        config.API_HOST + `/admin/system/supplier/template/download`;
    },
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <supplierTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            ></supplierTemplate>
          );
        },
      });
    },
  },
};
</script>
<style scoped>
.green {
  background-color: #e4f3e5;
  color: #4baf50;
  border-radius: 5px;
  padding: 0 5px;
}

.red {
  background-color: #fcd9dd;
  color: #ec0019;
  border-radius: 5px;
  padding: 0 5px;
}

.yellow {
  background-color: #fafcd9;
  color: #bdc824;
  border-radius: 5px;
  padding: 0 5px;
}
</style>
